<template>
  <div>
    <el-form role="form" @submit.prevent.native="onSubmit">
      <div class="row">
        <div class="col-md-6">
          <base-input label="Name" v-model="paymentMode.label" v-uppercase></base-input>
        </div>
      </div>
      <base-button md type="primary" native-type="submit">Save</base-button>
    </el-form>
  </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import { Form } from "element-ui";
export default {
  directives: {
    uppercase: {
      inserted: function(el, _, vnode) {
        el.addEventListener("input", async function(e) {
          const modified = e.target.value
            .split(" ")
            .map(i => i.charAt(0).toUpperCase() + i.slice(1))
            .join(" ");
          vnode.componentInstance.$emit("input", modified);
        });
      }
    }
  },
  data: () => {
    return {};
  },

  computed: {
    ...mapState("paymentMode", ["paymentMode"])
  },
  components: {
    [Form.name]: Form
  },
  methods: {
    ...mapActions({
      savePaymentMode: "paymentMode/savePaymentMode",
      updatePaymentMode: "paymentMode/updatePaymentMode",
      getPaymentModes: "paymentMode/getPaymentModes"
    }),
    onSubmit() {
      if (this.paymentMode.paymentModeId) {
        this.updatePaymentMode().then(res => {
          this.$notify({
            message: "Payment Mode Updated Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getPaymentModes();
          this.$emit("close");
        });
      } else {
        this.savePaymentMode().then(res => {
          this.$notify({
            message: "Payment Mode Created Succesfully!",
            type: "success",
            title: "Success"
          });
          this.getPaymentModes();
          this.$emit("close");
        });
      }
    }
  }
};
</script>